module.exports = __webpack_public_path__ + "img/3.d8e269d7.jpg";